import Axios from "axios";
import { getToken } from "../Store/Actions/API/authActions";

export const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  crossdomain: true,
  withCredentials: true,
});

axios.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;

  return config;
});

axios.interceptors.response.use(
  async (config) => {
    return config;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
    }

    return Promise.reject(error);
  }
);

export default axios;
